import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-arena pt-[120px] md:pt-[192px] pb-20 md:pb-[120px]" data-id="element-29" data-mp="3tb55s2qpu1k">
      <div className="max-w-[720px] mx-auto px-6 md:px-20 text-center" data-id="element-30" data-mp="3r85shfp6ok6">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-31" data-mp="8kkv6ts7azdz">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-32" data-mp="3gz2zckf0tusb">
            DIAGNÓSTICO ICD™
          </span>

          <h1 className="font-display text-[40px] md:text-[64px] font-bold text-carbon leading-[1.05] tracking-tightest mb-6" data-id="element-33" data-mp="3m1aax8vxv8u4">
            Descubre la puntuación digital de tu empresa.
          </h1>

          <p className="font-body text-[18px] md:text-[20px] text-carbon/65 leading-[1.6] mb-10" data-id="element-34" data-mp="167ta25xp5a70">
            En 48 horas recibirás el análisis completo de las cinco dimensiones
            de tu presencia digital, con recomendaciones específicas para tu
            empresa.
          </p>

          {/* Progress Indicator */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8" data-id="element-35" data-mp="12fzil9lj2utw">
            <div className="flex items-center gap-2" data-id="element-36" data-mp="xih5d70h9tg3">
              <span className="font-body text-[13px] font-medium text-verde" data-id="element-37" data-mp="xk21v26crmgl">
                1 Solicitud
              </span>
            </div>
            <span className="hidden md:block text-carbon/20" data-id="element-38" data-mp="nrmhxzbhwnt2">→</span>
            <div className="flex items-center gap-2" data-id="element-39" data-mp="jqarxsopm0kc">
              <span className="font-body text-[13px] font-medium text-carbon/30" data-id="element-40" data-mp="jqsvladpbh2a">
                2 Análisis 48h
              </span>
            </div>
            <span className="hidden md:block text-carbon/20" data-id="element-41" data-mp="9rty8nydz7ul">→</span>
            <div className="flex items-center gap-2" data-id="element-42" data-mp="9u7p0km19xwc">
              <span className="font-body text-[13px] font-medium text-carbon/30" data-id="element-43" data-mp="4sqt73iep1mm">
                3 Recibe Informe
              </span>
            </div>
          </div>

          <p className="font-body text-[13px] text-carbon/45 italic" data-id="element-44" data-mp="4hhovrvxhli">
            Análisis realizado por el equipo de Origen Studio. No automatizado.
            No genérico.
          </p>
        </motion.div>
      </div>
    </section>;
}